module.exports = __webpack_public_path__ + "img/kn.4ad12564.svg";